import { render } from "./CashlessInsurance.vue?vue&type=template&id=6e57e3e4"
import script from "./CashlessInsurance.vue?vue&type=script&lang=js"
export * from "./CashlessInsurance.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__